// noinspection DuplicatedCode
import React, { useEffect, useState, useMemo } from "react";
import { useRef } from "react";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { fetchPostMultipartSeaweed } from "../../../fetchers";
import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut, fetchPostMultipart } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { components } from "react-select";

// Akses penuh form Kas Bank = bagian FAP (Finance, Accounting & Procurement,
// B0005), TANPA memandang Bisnis Unit — semua field diisi manual, termasuk
// memilih Bisnis Unit sendiri. Bagian lain = user biasa: permohonan Pengeluaran
// saja (JenisTransaksi dikunci "Pengeluaran" — dulu "Downpayment PO", diganti
// 2026-09-09 karena mayoritas pengajuan user biasa memang pengeluaran biasa,
// bukan uang muka PO). Syarat "harus HO (U0001)" pernah ada (2026-07-23) lalu
// dicabut atas permintaan user: FAP di SO pun berhak penuh.
const FAP_BAGIAN = "B0005";
// COA satu-satunya yang boleh dipakai user non-FAP di detail (Pembelian Barang),
// terkunci read-only saat popup.
const COA_NONFAP = "1117002";

const InsertKasBankPage = ({}) => {
  // Tambahkan state untuk mode down payment
  const [isDownPaymentMode, setIsDownPaymentMode] = useState(false);
  const [availablePOs, setAvailablePOs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Format Date to YYYY-MM-DD using local timezone (avoids UTC 1-day shift)
  const toLocalDateString = (d) => {
    const date = d instanceof Date ? d : new Date(d || new Date());
    if (isNaN(date.getTime())) return toLocalDateString(new Date());
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  // Convert local date to ISO string without UTC day-shift
  const toLocalISO = (d) => {
    const date = d instanceof Date ? d : new Date(d);
    const offsetMs = date.getTimezoneOffset() * 60 * 1000;
    return new Date(date.getTime() - offsetMs).toISOString();
  };

  // Helper function untuk membuat tanggal yang valid
  const getValidDate = (dateValue) => {
    if (!dateValue) return new Date();

    try {
      // Jika sudah Date object dan valid
      if (dateValue instanceof Date && !isNaN(dateValue.getTime())) {
        return dateValue;
      }

      // Jika string ISO format (dari database)
      if (typeof dateValue === "string") {
        // Handle format ISO (2024-01-18T10:30:00Z)
        if (dateValue.includes("T")) {
          const isoDate = new Date(dateValue);
          if (!isNaN(isoDate.getTime())) {
            return isoDate;
          }
        }

        // Handle format date only (2024-01-18)
        if (dateValue.includes("-")) {
          // Tambahkan waktu agar valid
          const dateWithTime = `${dateValue}T00:00:00`;
          const parsedDate = new Date(dateWithTime);
          if (!isNaN(parsedDate.getTime())) {
            return parsedDate;
          }
        }
      }

      // Default ke hari ini jika parsing gagal
      console.warn("Invalid date value, using today:", dateValue);
      return new Date();
    } catch (error) {
      console.error("Error parsing date:", error, "Value:", dateValue);
      return new Date();
    }
  };

  let initialState = {
    BisnisUnitID: "U0001",
    JenisTransaksi: "Pengeluaran",
    Tanggal: new Date(),
    TanggalKeperluan: "",
    Attachment: null,
    FileName: "",
    File: "",
    BagianID: "",
    OriginalFileName: "",
    Status: "-1",
    SumberData: "",
    PurchaseOrderID: "",
    MataUang: "",
    NominalPO: "0",
    Nominal: "0",
    DariKepada: "",
    NoCek: "",
    Keterangan: "",
    JenisCashJournal: "",
    DetailCashJournal: "",
  };

  let initialStateModal = {
    SDTDate: new Date(),
    Account: "",
    Keterangan: "",
    Nominal: "",
  };

  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [fileUploadError, setFileUploadError] = useState(false);
  const mutationFileUpload = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData),
  );

  // Mutation untuk mengambil data PO dari API
  const mutationGetPO = useMutation(() =>
    fetchGet("all/GetPurchaseOrderPembayaran"),
  );

  // Format options untuk react-select
  const poOptions = useMemo(() => {
    return availablePOs.map((po) => {
      const grandTotal = po.GrandTotal || 0;
      const terbayar = po.Terbayar || 0;
      const sisaBayar = grandTotal - terbayar;

      return {
        value: po.PurchaseOrderID,
        label: `${po.PurchaseOrderID} - ${po.NamaSupplier}`,
        data: po,
      };
    });
  }, [availablePOs]);

  // Filter options berdasarkan search query
  const filteredOptions = useMemo(() => {
    if (!searchQuery.trim()) return poOptions;

    const query = searchQuery.toLowerCase();
    return poOptions.filter((option) => {
      const po = option.data;
      return (
        po.PurchaseOrderID.toLowerCase().includes(query) ||
        (po.NamaSupplier || "").toLowerCase().includes(query) ||
        (po.Remarks || "").toLowerCase().includes(query)
      );
    });
  }, [poOptions, searchQuery]);

  // Handler untuk select PO
  const handlePOSelectChange = (selectedOption) => {
    if (selectedOption) {
      const selectedPO = selectedOption.data;

      if (!selectedPO || !selectedPO.PurchaseOrderID) {
        toast.error("Data PO tidak valid", {
          position: "bottom-right",
          autoClose: 3000,
        });
        return;
      }

      const grandTotal = selectedPO.GrandTotal
        ? selectedPO.GrandTotal.toString()
        : "0";
      const terbayar = selectedPO.Terbayar
        ? selectedPO.Terbayar.toString()
        : "0";
      // Sisa bayar dijaga tak negatif. Terbayar kini nilai NYATA dari backend
      // (Σ pembayaran approved kedua jalur), bukan lagi konstanta 0.
      const sisaBayar = Math.max(
        0,
        parseFloat(grandTotal) - parseFloat(terbayar),
      );
      const sudahLunas = sisaBayar <= 0;

      // Pra-isi nominal dgn SISA (bukan grandTotal), agar pembayaran sebagian
      // berikutnya benar. PO lunas -> 0 (dan diberi peringatan di bawah).
      const nominalBayar = sisaBayar.toString();
      const keteranganBayar =
        selectedPO.Remarks ||
        `Pembayaran untuk PO ${selectedPO.PurchaseOrderID}`;

      const blastchanges = {
        SumberData: selectedPO.PurchaseOrderID,
        PurchaseOrderID: selectedPO.PurchaseOrderID,
        DariKepada: selectedPO.NamaSupplier || "",
        MataUang: selectedPO.Currency || "IDR",
        NominalPO: grandTotal,
        Nominal: nominalBayar,
        NoCek: selectedPO.PurchaseOrderID || "",
        Keterangan: keteranganBayar,
      };

      blastChange(blastchanges);
      setIsDownPaymentMode(true);

      // Biaya Lain-lain PC (2026-10-14) TIDAK dicampur ke nominal/sisa bayar di sini:
      // dibukukan saat penerimaan barang & ditagih lewat Pembayaran AP (baris otomatis).
      if ((parseFloat(selectedPO.BiayaLain) || 0) > 0) {
        toast.info(
          `PO ${selectedPO.PurchaseOrderID} punya Biaya Lain-lain Rp ${formatNumber(parseFloat(selectedPO.BiayaLain))}${selectedPO.KeteranganBiayaLain ? " (" + selectedPO.KeteranganBiayaLain + ")" : ""} di luar nominal ini — ditagih lewat Pembayaran AP.`,
          {position: "bottom-right", autoClose: 7000},
        );
      }

      // PRA-ISI baris lawan (Debet) dari PO agar jurnal tidak satu-sisi.
      // LawanAccountID dari backend: Dr Hutang bila sudah diterima via GA, else
      // Dr akun item PO. Bila kosong (mis. PO Jasa / barang non-master), biarkan
      // kosong — operator melengkapi manual via "Tambah Data".
      // PO yang sudah lunas tidak dipra-isi (tak ada sisa yang harus dibayar).
      if (sudahLunas) {
        setDetail([]);
        toast.warning(
          `PO ${selectedPO.PurchaseOrderID} sudah LUNAS (terbayar Rp ${formatNumber(parseFloat(terbayar))}). Tidak ada sisa pembayaran.`,
          {position: "bottom-right", autoClose: 5000},
        );
      } else if (selectedPO.LawanAccountID) {
        setDetail([
          {
            Account: selectedPO.LawanAccountID,
            Keterangan: keteranganBayar,
            Nominal: nominalBayar,
          },
        ]);
      } else {
        setDetail([]);
        toast.info(
          "Akun lawan PO tidak dikenali otomatis — isi Detail Pembayaran secara manual.",
          {position: "bottom-right", autoClose: 4000},
        );
      }

      toast.success(`Data PO ${selectedPO.PurchaseOrderID} berhasil dimuat`, {
        position: "bottom-right",
        autoClose: 2000,
      });

      if (sisaBayar > 0 && sisaBayar < parseFloat(grandTotal)) {
        toast.info(
          `Sisa pembayaran: Rp ${formatNumber(sisaBayar)} dari total Rp ${formatNumber(grandTotal)}`,
          {
            position: "bottom-right",
            autoClose: 3000,
          },
        );
      }
    } else {
      // Reset jika dikosongkan
      const resetFields = {
        SumberData: "",
        PurchaseOrderID: "",
        MataUang: "",
        DariKepada: "",
        NoCek: "",
        NominalPO: "0",
        Nominal: "0",
        Keterangan: "",
      };
      blastChange(resetFields);
      setIsDownPaymentMode(false);
      // Bersihkan baris lawan yang tadi dipra-isi dari PO, agar tak tertinggal
      // saat PO dilepas.
      setDetail([]);
    }
  };

  const getDataFromURL = (url) => {
    if (!url || url.trim() === "") {
      toast.error("Tidak ada file attachment", {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }

    const encodedUrl = encodeURIComponent(url);
    const fileUrl = process.env.REACT_APP_API_UPLOAD_URL
      ? `${process.env.REACT_APP_API_UPLOAD_URL}file/${encodedUrl}`
      : `http://192.168.212.24:5000/v1/files/${encodedUrl}`;

    fetch(fileUrl, {
      method: "GET",
      headers: {
        Accept: "application/octet-stream",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.blob();
      })
      .then((blob) => {
        const fileBlobUrl = window.URL.createObjectURL(blob);

        if (blob.type.includes("pdf") || blob.type.includes("image")) {
          window.open(fileBlobUrl, "_blank");
        } else {
          const link = document.createElement("a");
          link.href = fileBlobUrl;

          let downloadName = url;
          if (url.includes("-") && url.split("-")[0].length === 36) {
            const uuidParts = url.split("-");
            downloadName = uuidParts.slice(1).join("-").replace(/_/g, " ");
          }

          link.download = downloadName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setTimeout(() => URL.revokeObjectURL(fileBlobUrl), 100);
        }

        toast.success("File berhasil dibuka", {
          position: "bottom-right",
          autoClose: 2000,
        });
      })
      .catch((err) => {
        console.error("Error loading file:", err);
        toast.error(
          "Gagal membuka file. File mungkin belum diupload ke server.",
          {
            position: "bottom-right",
            autoClose: 3000,
          },
        );
      });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error("Ukuran file maksimal 10MB!", {
          position: "bottom-right",
          autoClose: 3000,
        });
        event.target.value = "";
        return;
      }

      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "image/jpg",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];

      if (!allowedTypes.includes(file.type)) {
        toast.error(
          "Format file tidak didukung! Gunakan PDF, JPG, PNG, atau DOC.",
          {
            position: "bottom-right",
            autoClose: 3000,
          },
        );
        event.target.value = "";
        return;
      }

      setSelectedFile(file);
      customHandler(file.name, "FileName");
      customHandler(file.name, "OriginalFileName");
      setFileUploadError(false);

      toast.success("File siap diupload", {
        position: "bottom-right",
        autoClose: 2000,
      });
    }
  };

  const validations = [
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ JenisTransaksi }) =>
      isRequired(JenisTransaksi) || {
        JenisTransaksi: "Jenis Transaksi wajib diisi",
      },
    ({ BisnisUnitID }) =>
      isRequired(BisnisUnitID) || { BisnisUnitID: "Bisnis Unit wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
    multiFieldHandler,
  } = useForm(initialState, validations);

  // Peran user login menentukan perilaku form: hanya user HO + bagian FAP yang
  // boleh mengisi sisi kas/bank (Jenis/Detail Pembayaran, No Cek), memilih COA
  // detail, serta memilih sendiri Bisnis Unit & Bagian. User lain hanya membuat
  // permohonan Pengeluaran (isi keperluan+nominal).
  const currentUser = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "null") || {};
    } catch {
      return {};
    }
  }, []);
  // Bagian dipakai sebagai satu-satunya penentu peran. Sesi lama yang belum punya
  // BagianID di localStorage di-resolve async lewat getDetailKaryawan pada
  // useEffect mount — karena itu peran dibaca dari state, bukan dari currentUser.
  const [userBagian, setUserBagian] = useState(currentUser?.BagianID || "");
  const isFAP = userBagian === FAP_BAGIAN;

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);

  const ModalOpener = (detail) => {
    // Non-FAP: COA dikunci ke 1117002 (read-only), user hanya isi nominal.
    setModalDetail(
      isFAP
        ? initialStateModal
        : { ...initialStateModal, Account: COA_NONFAP },
    );
    setShowModal(true);
  };

  const param = useLocation();
  const params = useParams();

  const mutation = useMutation((formData) =>
    fetchPost("Master/UserPC", formData),
  );
  const mutationAdd = useMutation((formData) =>
    fetchPost("Accounting/CashJournal", formData),
  );
  const mutationGet = useMutation((formData) =>
    fetchGet("Accounting/CashJournal/" + formData),
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Accounting/CashJournal", formData),
  );
  const mutationApproval = useMutation((formData) =>
    fetchPost("Accounting/CashJournal/kirim", formData),
  );
  const detailAccount = useMutation((formData) =>
    fetchGet("GetMinMasterDetailAccountV2"),
  );

  const ModalEdit = (detail, id) => {
    if (detail && id !== undefined) {
      setModalID(id);
      setModalDetail(detail);
      setShowModal(true);
      setShowModalEdit(true);
    }
  };

  const ModalDelete = (id) => {
    if (id !== undefined) {
      const newDetail = [...detail];
      newDetail.splice(id, 1);
      setDetail(newDetail);

      // Hitung ulang total
      setTimeout(() => calculateTotal(), 0);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    setIsDownPaymentMode(false);
    detailAccount.mutate();
    barang.mutate();

    const isCreate = !params.transid;
    if (params.transid) {
      mutationGet.mutate(params.transid.toString().replaceAll("-", "/"));
    }

    // Peran dipakai di kedua mode (buat & edit), jadi Bagian user tetap di-resolve
    // walau sedang mengedit. Yang khusus mode BUAT BARU: kunci Bisnis Unit &
    // Bagian ke milik user login + kunci Jenis Transaksi ke "Pengeluaran".
    // User FAP dilewati — semua field diisi manual, apa pun Bisnis Unit-nya.
    // Pakai multiFieldHandler (MERGE) — blastChange itu REPLACE (menghapus field
    // lain spt Tanggal/Status).
    const applyUser = (bu, bagian) => {
      const unit = bu || "";
      const div = bagian || currentUser?.BagianID || "";
      if (div) setUserBagian(div);
      if (!isCreate) return;
      if (div === FAP_BAGIAN) return;
      const patch = { BagianID: div, JenisTransaksi: "Pengeluaran" };
      if (unit) patch.BisnisUnitID = unit;
      multiFieldHandler(patch);
    };

    if (currentUser?.BisnisUnitID) {
      // Sesi baru: BU sudah ada dari response login.
      applyUser(currentUser.BisnisUnitID, currentUser.BagianID);
    } else if (currentUser?.Nik) {
      // Sesi lama (login sebelum BU ditambahkan ke response) → ambil by Nik.
      // CheckAuth backend no-op, jadi endpoint ini bisa dipanggil semua user.
      const fd = new FormData();
      fd.append("Nik", currentUser.Nik);
      fetchPostMultipart("getDetailKaryawan", fd)
        .then((res) => {
          const row = res?.data?.[0];
          applyUser(row?.BisnisUnitID, row?.BagianID);
          if (!row?.BisnisUnitID && isCreate) {
            toast.info("Bisnis Unit user tidak terdeteksi.", {
              position: "top-center",
              autoClose: 4000,
            });
          }
        })
        .catch(() => {
          applyUser("", "");
          if (isCreate) {
            toast.info(
              "Gagal mengambil Bisnis Unit user — silakan login ulang.",
              { position: "top-center", autoClose: 4000 },
            );
          }
        });
    } else {
      applyUser("", "");
    }
  }, []);

  useEffect(() => {
    if (mutationUpdate.isSuccess) {
      toast.success("Data berhasil diperbarui", {
        position: "bottom-right",
        autoClose: 3000,
      });
      navigate("/finance/kas-bank");
    }
    if (mutationUpdate.isError) {
      toast.error("Gagal memperbarui data", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (mutationAdd.isSuccess) {
      toast.success("Data berhasil disimpan", {
        position: "bottom-right",
        autoClose: 3000,
      });
      navigate("/finance/kas-bank");
    }
    if (mutationAdd.isError) {
      toast.error("Gagal menyimpan data", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  }, [mutationAdd.status]);

  useEffect(() => {
    if (mutationApproval.isSuccess) {
      toast.success("Data berhasil dikirim untuk approval", {
        position: "bottom-right",
        autoClose: 3000,
      });
      navigate("/finance/kas-bank");
    }
    if (mutationApproval.isError) {
      toast.error("Gagal mengirim data", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  }, [mutationApproval.status]);

  useEffect(() => {
    if (mutationGet.data && mutationGet.data.data && mutationGet.data.data[0]) {
      const tempData = mutationGet.data.data[0];

      // Pastikan Data adalah array
      const loadedDetail = Array.isArray(tempData.Data) ? tempData.Data : [];
      setDetail(loadedDetail);

      // Konsep form kini HANYA "Pembayaran Non PO" — mode Down Payment sudah
      // dihapus. Selalu false agar layout & format Nominal (numberView) konsisten.
      // (Dulu memakai hasDownPaymentData yang keliru true krn NominalPO "0.00" !== "0".)
      setIsDownPaymentMode(false);

      // Set uploadedFileName jika ada file dari database
      if (tempData.File && tempData.File.trim() !== "") {
        setUploadedFileName(tempData.File);
        customHandler(tempData.File, "File");

        if (
          tempData.File.includes("-") &&
          tempData.File.split("-")[0].length === 36
        ) {
          const uuidParts = tempData.File.split("-");
          const originalName = uuidParts.slice(1).join("-").replace(/_/g, " ");
          customHandler(originalName, "FileName");
        } else {
          customHandler(tempData.File, "FileName");
        }
      }

      // Bersihkan dan format data sebelum di-blastChange
      const cleanedData = {
        SumberData: tempData.SumberData || "",
        PurchaseOrderID: tempData.PurchaseOrderID || "",
        MataUang: tempData.MataUang || "",
        NominalPO: tempData.NominalPO ? String(parseFloat(tempData.NominalPO) || 0) : "0",
        ...tempData,
        Tanggal: getValidDate(tempData.Tanggal),
        Nominal: tempData.Nominal ? String(parseFloat(tempData.Nominal) || 0) : "0",
      };

      // Hapus field yang tidak perlu
      delete cleanedData.Data;
      delete cleanedData.File;
      delete cleanedData.FileName;

      // Gunakan setTimeout untuk memberikan waktu render
      setTimeout(() => {
        blastChange(cleanedData);
      }, 100);
    }
  }, [mutationGet.status]);

  // Load data PO saat mode down payment diaktifkan
  const loadPurchaseOrders = () => {
    mutationGetPO.mutate(undefined, {
      onSuccess: (data) => {
        if (data && data.data) {
          setAvailablePOs(data.data);
        }
      },
      onError: (error) => {
        console.error("Gagal mengambil data PO:", error);
        toast.error("Gagal mengambil data Purchase Order", {
          position: "bottom-right",
          autoClose: 3000,
        });
      },
    });
  };

  useEffect(() => {
    if (isDownPaymentMode && !params.approval && !params.transid) {
      loadPurchaseOrders();
    }
  }, [isDownPaymentMode]);

  const header = [
    { name: "Account", key: "Account", modifiers: "Account" },
    { name: "Account Name", key: "Account", modifiers: "AccountName" },
    { name: "Keterangan", key: "Keterangan", modifiers: "Keterangan" },
    { name: "Nominal", key: "Nominal", modifiers: "Numbers" },
    { name: "tools", key: "EditDelete", modifiers: "EditDelete" },
  ];

  const modalHandler = (value, names) => {
    const newValues = { ...modalDetail, [names]: value };
    setModalDetail(newValues);
  };

  const modalHandlerText = (event) => {
    const newValues = {
      ...modalDetail,
      [event.target.name]: event.target.value,
    };
    setModalDetail(newValues);
  };

  // NumberFormat (react-number-format) memanggil onValueChange dengan objek
  // {formattedValue, value, floatValue} — bukan event DOM — sehingga tampilan
  // boleh berpemisah-ribuan sementara nilai yang disimpan tetap angka murni
  // (pola sama dgn SaldoAwal.js).
  const modalHandlerNominal = (values) => {
    const newValues = { ...modalDetail, Nominal: values.floatValue?.toString() || "" };
    setModalDetail(newValues);
  };

  const inputBuilder = [
    {
      type: "DetailAccount",
      name: "Account",
      title: "Account",
      handler: modalHandler,
      size: "full",
      required: true,
      // Non-FAP: COA terkunci (hanya 1117002, read-only).
      disabled: !isFAP,
      edit: false,
    },
    {
      type: "text",
      name: "Keterangan",
      title: "Keterangan",
      handler: modalHandlerText,
      size: "full",
      required: true,
      disabled: false,
      edit: false,
    },
    {
      type: "numberFormatSatu",
      name: "Nominal",
      title: "Nominal",
      handler: modalHandlerNominal,
      size: "full",
      required: true,
      disabled: false,
      edit: false,
    },
  ];

  // Fungsi untuk menghitung total
  const calculateTotal = () => {
    try {
      let totalDetail = 0;
      detail.forEach((item) => {
        const nominal = parseFloat(item.Nominal || 0);
        if (!isNaN(nominal)) {
          totalDetail += nominal;
        }
      });

      // Untuk mode down payment, total = NominalPO + total detail
      if (isDownPaymentMode && values.PurchaseOrderID) {
        const nominalPO = parseFloat(values.NominalPO || 0);
        const total = nominalPO + totalDetail;

        // Update field Nominal (total) - PASTIKAN HANYA JIKA NILAI BERBEDA
        if (Math.abs(parseFloat(values.Nominal || 0) - total) > 0.01) {
          customHandler(total.toString(), "Nominal");
        }

        return total;
      } else {
        // Untuk mode regular, total hanya dari detail
        if (Math.abs(parseFloat(values.Nominal || 0) - totalDetail) > 0.01) {
          customHandler(totalDetail.toString(), "Nominal");
        }
        return totalDetail;
      }
    } catch (error) {
      console.error("Error calculating total:", error);
      return 0;
    }
  };

  // Format number untuk display
  const formatNumber = (num) => {
    try {
      const number = parseFloat(num || 0);
      return isNaN(number) ? "0" : number.toLocaleString("id-ID");
    } catch {
      return "0";
    }
  };

  // Handler untuk perubahan nominal PO di mode down payment
  const handleNominalPOChange = (e) => {
    const value = e.target.value;
    customHandler(value, "NominalPO");

    // Hitung ulang total
    setTimeout(() => {
      calculateTotal();
    }, 0);
  };

  // ========== Fungsi Kirim ==========
  const Kirim = async () => {
    // Buat payload dengan semua field yang diperlukan
    const payload = {
      // TAMBAHKAN: CashJournalID untuk update (WAJIB untuk update)
      CashJournalID: params.transid ? params.transid.replaceAll("-", "/") : "",

      // Field utama (selalu ada)
      BisnisUnitID: values.BisnisUnitID || "",
      JenisTransaksi: values.JenisTransaksi || "Pengeluaran",
      Tanggal: toLocalISO(getValidDate(values.Tanggal || new Date())),
      BagianID: values.BagianID || "",
      TanggalKeperluan: values.TanggalKeperluan || "",
      Status: params.transid ? "1" : "-1",
      JenisCashJournal: values.JenisCashJournal || "",
      DetailCashJournal: values.DetailCashJournal || "",
      DariKepada: values.DariKepada || "",
      NoCek: values.NoCek || "",
      Keterangan: values.Keterangan || "",
      Type: "NonPO",
      Data: detail || [],

      // Field down payment - SELALU DIKIRIM (kosong jika tidak ada)
      SumberData: values.SumberData || "",
      PurchaseOrderID: values.PurchaseOrderID || "",
      MataUang: values.MataUang || "",
      NominalPO: String(parseFloat(values.NominalPO) || 0),

      // Field khusus down payment (untuk insert dan update)
      JenisPembayaran: isDownPaymentMode ? values.JenisCashJournal || "" : "",
      DetailPembayaran: isDownPaymentMode ? values.DetailCashJournal || "" : "",
    };

    // Handle file upload
    let fileNameToSave = "";
    setFileUploadError(false);

    if (selectedFile) {
      setIsUploading(true);

      const uuid = uuidv4();
      const safeFileName = selectedFile.name.replace(/\s+/g, "_");
      const fileNameWithUUID = `${uuid}-${safeFileName}`;

      fileNameToSave = fileNameWithUUID;

      try {
        const formData = new FormData();
        formData.append("file", selectedFile, fileNameWithUUID);

        try {
          const response = await mutationFileUpload.mutateAsync(formData);
          setUploadedFileName(fileNameWithUUID);
          setFileUploadError(false);

          toast.success("File berhasil diupload", {
            position: "bottom-right",
            autoClose: 2000,
          });
        } catch (uploadError) {
          fileNameToSave = fileNameWithUUID;
          setFileUploadError(true);

          toast.warning(
            "Upload file gagal, tetapi nama file tetap disimpan di database. File tidak akan tersedia untuk di-download.",
            {
              position: "bottom-right",
              autoClose: 4000,
            },
          );
        }
      } catch (error) {
        console.error("Error dalam proses upload:", error);
        fileNameToSave = fileNameWithUUID;
        setFileUploadError(true);
      } finally {
        setIsUploading(false);
      }
    } else if (uploadedFileName && params.transid) {
      fileNameToSave = uploadedFileName;
    } else if (values.File && values.File.trim() !== "") {
      fileNameToSave = values.File;
    }

    // Tambahkan file ke payload
    payload.File = fileNameToSave || "";

    // Hitung dan tambahkan Nominal (total)
    const total = calculateTotal();
    payload.Nominal = total.toString();

    // Hapus field yang tidak diperlukan backend
    delete payload.Attachment;
    delete payload.OriginalFileName;
    delete payload.FileName;


    if (params.transid) {
      mutationUpdate.mutate(payload);
    } else {
      mutationAdd.mutate(payload);
    }
  };

  // ========== Fungsi Approve ==========
  const Approve = () => {
    // Buat payload dengan semua field yang diperlukan
    const payload = {
      // TAMBAHKAN: CashJournalID untuk update (WAJIB untuk update)
      CashJournalID: params.transid ? params.transid.replaceAll("-", "/") : "",

      // Field utama (selalu ada)
      BisnisUnitID: values.BisnisUnitID || "",
      JenisTransaksi: values.JenisTransaksi || "Pengeluaran",
      Tanggal: toLocalISO(getValidDate(values.Tanggal || new Date())),
      BagianID: values.BagianID || "",
      TanggalKeperluan: values.TanggalKeperluan || "",
      Status: "1", // Untuk approval
      JenisCashJournal: values.JenisCashJournal || "",
      DetailCashJournal: values.DetailCashJournal || "",
      DariKepada: values.DariKepada || "",
      NoCek: values.NoCek || "",
      Keterangan: values.Keterangan || "",
      Type: "NonPO",
      Data: detail || [],

      // Field down payment - SELALU DIKIRIM (kosong jika tidak ada)
      SumberData: values.SumberData || "",
      PurchaseOrderID: values.PurchaseOrderID || "",
      MataUang: values.MataUang || "",
      NominalPO: String(parseFloat(values.NominalPO) || 0),

      // Field khusus down payment
      JenisPembayaran: isDownPaymentMode ? values.JenisCashJournal || "" : "",
      DetailPembayaran: isDownPaymentMode ? values.DetailCashJournal || "" : "",
    };

    // Tambahkan file
    payload.File = values.File || uploadedFileName || "";

    // Hitung dan tambahkan Nominal (total)
    const total = calculateTotal();
    payload.Nominal = total.toString();

    // Hapus field yang tidak diperlukan backend
    delete payload.Attachment;
    delete payload.OriginalFileName;
    delete payload.FileName;


    mutationApproval.mutate(payload);
  };

  const removeFile = () => {
    setSelectedFile(null);
    setUploadedFileName("");
    setFileUploadError(false);
    blastChange({ ...values, FileName: "", File: "", OriginalFileName: "" });

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    toast.success("File berhasil dihapus", {
      position: "bottom-right",
      autoClose: 2000,
    });
  };

  const getFileIcon = (fileName) => {
    if (!fileName) return "📎";
    const ext = fileName.split(".").pop().toLowerCase();
    if (["pdf"].includes(ext)) return "📄";
    if (["jpg", "jpeg", "png", "gif"].includes(ext)) return "🖼️";
    if (["doc", "docx"].includes(ext)) return "📝";
    return "📎";
  };

  const getDisplayFileName = () => {
    if (selectedFile) {
      return selectedFile.name;
    }
    if (values.FileName && values.FileName.trim() !== "") {
      return values.FileName;
    }
    if (uploadedFileName) {
      if (
        uploadedFileName.includes("-") &&
        uploadedFileName.split("-")[0].length === 36
      ) {
        const uuidParts = uploadedFileName.split("-");
        return uuidParts.slice(1).join("-").replace(/_/g, " ");
      }
      return uploadedFileName;
    }
    return null;
  };

  const displayFileName = getDisplayFileName();

  // Handler untuk toggle mode down payment
  const handleModeToggle = (e) => {
    const isDownPayment = e.target.value === "downpayment";

    // Jika mode berubah
    if (isDownPayment !== isDownPaymentMode) {
      setIsDownPaymentMode(isDownPayment);

      if (isDownPayment) {
        // Switch ke mode down payment
        // Reset field down payment
        const resetFields = {
          SumberData: "",
          PurchaseOrderID: "",
          MataUang: "",
          DariKepada: "",
          NoCek: "",
          NominalPO: "0",
          Nominal: "0",
        };
        blastChange(resetFields);
        setDetail([]);

        // Load data PO saat mode down payment diaktifkan
        if (!params.approval && !params.transid) {
          loadPurchaseOrders();
        }
      } else {
        // Switch ke mode regular
        // Reset field down payment, pertahankan field regular
        const resetFields = {
          SumberData: "",
          PurchaseOrderID: "",
          MataUang: "",
          NoCek: "",
          NominalPO: "0",
          Nominal: "0",
        };
        blastChange(resetFields);

        // Kosongkan detail
        setDetail([]);
      }

      toast.info(
        `Berhasil beralih ke mode ${isDownPayment ? "Uang Muka PO" : "Pembayaran Non-PO"}`,
        {
          position: "bottom-right",
          autoClose: 2000,
        },
      );
    }
  };

  // Tambah detail dari modal
  const addDetail = () => {
    try {
      // Validasi modalDetail
      if (
        !modalDetail.Account ||
        !modalDetail.Nominal ||
        isNaN(parseFloat(modalDetail.Nominal)) // Hanya validasi jika bukan angka
      ) {
        toast.error("Harap isi Account dan Nominal dengan benar", {
          position: "bottom-right",
          autoClose: 3000,
        });
        return;
      }

      if (showModalEdit) {
        // Edit detail
        const newDetails = [...detail];
        newDetails[modalID] = modalDetail;
        setDetail(newDetails);
      } else {
        // Tambah detail baru
        const newDetails = [...detail, modalDetail];
        setDetail(newDetails);
      }

      // Reset modal
      setModalDetail(initialStateModal);
      setShowModal(false);
      setShowModalEdit(false);

      // Hitung ulang total
      setTimeout(() => {
        calculateTotal();
      }, 100);

      toast.success(
        showModalEdit
          ? "Detail berhasil diubah"
          : "Detail berhasil ditambahkan",
        {
          position: "bottom-right",
          autoClose: 2000,
        },
      );
    } catch (error) {
      console.error("Error adding detail:", error);
      toast.error("Gagal menambahkan detail", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };

  // Custom handler untuk tanggal yang aman
  const safeDateHandler = (value, name) => {
    try {
      const validDate = getValidDate(value);
      customHandler(validDate, name);
    } catch (error) {
      console.error("Error in safeDateHandler:", error);
      customHandler(new Date(), name);
    }
  };

  // Hitung total saat ada perubahan
  useEffect(() => {
    calculateTotal();
  }, [values.NominalPO, detail, isDownPaymentMode]);

  // ========== (Dinonaktifkan) Auto set mode down payment ==========
  // Konsep form kini HANYA "Pembayaran Non PO" — mode DP dihapus, jadi tidak
  // pernah diaktifkan otomatis lagi (dulu bisa keliru aktif utk record legacy).


  // Custom styles untuk react-select
  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#f9fafb",
      borderColor: state.isFocused ? "#3b82f6" : "#d1d5db",
      borderRadius: "0.375rem",
      padding: "0.25rem",
      minHeight: "44px",
      boxShadow: state.isFocused ? "0 0 0 1px #3b82f6" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#3b82f6" : "#9ca3af",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#3b82f6"
        : state.isFocused
          ? "#e5e7eb"
          : "white",
      color: state.isSelected ? "white" : "#374151",
      padding: "8px 12px",
      fontSize: "0.875rem",
      "&:active": {
        backgroundColor: state.isSelected ? "#3b82f6" : "#d1d5db",
      },
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      borderRadius: "0.375rem",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9ca3af",
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#374151",
      fontSize: "0.875rem",
    }),
    input: (base) => ({
      ...base,
      color: "#374151",
      fontSize: "0.875rem",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#6b7280",
      padding: "4px",
      "&:hover": {
        color: "#374151",
      },
    }),
    clearIndicator: (base) => ({
      ...base,
      color: "#6b7280",
      padding: "4px",
      "&:hover": {
        color: "#ef4444",
      },
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: "#d1d5db",
    }),
  };

  // Custom Option component untuk menampilkan info PO
  const CustomOption = ({
    innerRef,
    innerProps,
    data,
    isSelected,
    isFocused,
  }) => {
    const po = data.data;
    const grandTotal = po.GrandTotal || 0;
    const terbayar = po.Terbayar || 0;
    const sisaBayar = grandTotal - terbayar;

    return (
      <div
        ref={innerRef}
        {...innerProps}
        className={`px-3 py-2 cursor-pointer transition-colors duration-150 ${isSelected ? "bg-blue-500 text-white" : isFocused ? "bg-gray-100" : "bg-white"}`}
      >
        <div className="flex flex-col">
          <div className="flex justify-between items-start">
            <div className="flex-1">
              <div className="font-medium">{po.PurchaseOrderID}</div>
              <div className="text-sm opacity-75">{po.NamaSupplier}</div>
            </div>
            <div
              className={`font-semibold ${isSelected ? "text-blue-100" : "text-blue-600"}`}
            >
              Rp {formatNumber(grandTotal)}
            </div>
          </div>
          {terbayar > 0 && (
            <div className="flex justify-between text-xs mt-1">
              <span className={isSelected ? "text-blue-200" : "text-gray-500"}>
                Terbayar: Rp {formatNumber(terbayar)}
              </span>
              {sisaBayar > 0 && (
                <span
                  className={isSelected ? "text-green-300" : "text-green-600"}
                >
                  Sisa: Rp {formatNumber(sisaBayar)}
                </span>
              )}
            </div>
          )}
          {po.Remarks && (
            <div
              className={`text-xs truncate mt-1 ${isSelected ? "text-blue-200" : "text-gray-400"}`}
            >
              {po.Remarks}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col mt-5 p-6">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() => navigate("/finance/kas-bank")}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>

                  {!params.approval ? (
                    <button
                      onClick={() => Kirim()}
                      disabled={
                        mutationAdd.isLoading ||
                        mutationUpdate.isLoading ||
                        isUploading
                      }
                      className={`flex flex-row items-center justify-center m-2 sm:my-0 py-2 px-4 border shadow rounded ${
                        mutationAdd.isLoading ||
                        mutationUpdate.isLoading ||
                        isUploading
                          ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                          : "bg-white hover:bg-main-100 hover:text-white text-gray-800"
                      }`}
                    >
                      {mutationAdd.isLoading ||
                      mutationUpdate.isLoading ||
                      isUploading ? (
                        <>
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline mr-3 w-4 h-4 text-white animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="#E5E7EB"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentColor"
                            />
                          </svg>
                          {isUploading ? "Uploading..." : "Loading"}
                        </>
                      ) : (
                        "Simpan"
                      )}
                    </button>
                  ) : (
                    <button
                      onClick={() => Approve()}
                      disabled={mutationApproval.isLoading || isUploading}
                      className={`flex flex-row items-center justify-center m-2 sm:my-0 py-2 px-4 border shadow rounded ${
                        mutationApproval.isLoading || isUploading
                          ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                          : "bg-white hover:bg-main-100 hover:text-white text-gray-800"
                      }`}
                    >
                      {mutationApproval.isLoading || isUploading ? (
                        <>
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline mr-3 w-4 h-4 text-white animate-spin"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="#E5E7EB"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentColor"
                            />
                          </svg>
                          {isUploading ? "Uploading..." : "Loading"}
                        </>
                      ) : (
                        "Kirim"
                      )}
                    </button>
                  )}
                </div>


                {/* Form Fields */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                  {/* Bisnis Unit — TERKUNCI ke unit user login, KECUALI user
                      HO+FAP yang mengisi semua field manual. */}
                  <HrdInputGenerator
                    type={"BisnisUnit"}
                    value={values}
                    name={"BisnisUnitID"}
                    title={"Bisnis Unit"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={!isFAP}
                  />

                  {/* Jenis Transaksi ("jenis pengeluaran"). Non-FAP dikunci ke
                      "Pengeluaran"; FAP bebas memilih. */}
                  {isFAP ? (
                    <HrdInputGenerator
                      type={"JenisTransaksiKasBankInput"}
                      value={values}
                      name={"JenisTransaksi"}
                      title={"Jenis Transaksi"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={!!params.approval}
                    />
                  ) : (
                    <div className="w-full px-3 mb-6">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                        Jenis Transaksi *
                      </label>
                      <input
                        type="text"
                        value="Pengeluaran"
                        readOnly
                        disabled
                        className="appearance-none block w-full bg-gray-100 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight cursor-not-allowed"
                      />
                    </div>
                  )}

                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"DariKepada"}
                    title={"Dibayar kepada"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={!!params.approval}
                  />

                  {/* Jenis Pembayaran (Kas/Bank) & Detail Pembayaran (akun kas/bank)
                      = sisi kas/bank jurnal. HANYA untuk FAP — non-FAP tak melihatnya
                      sama sekali (FAP melengkapinya saat proses/approval). */}
                  {isFAP && (
                    <>
                      <HrdInputGenerator
                        type={"JenisPenerimaan"}
                        value={values}
                        name={"JenisCashJournal"}
                        title={"Jenis Pembayaran"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={!!params.approval}
                      />

                      <HrdInputGenerator
                        type={"DetailPembayaran"}
                        value={values}
                        name={"DetailCashJournal"}
                        title={"Detail Pembayaran"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={!!params.approval}
                      />
                    </>
                  )}

                  {/* Bagian (divisi). Form ini SUDAH mengirim `BagianID` ke API dan
                      backend sudah menulis kolomnya — yang dulu hilang cuma widget
                      ini, sehingga semua Kas Bank NonPO tersimpan tanpa divisi dan
                      laporan tak bisa difilter per divisi.
                      OPSIONAL: `Bagianv3` menyediakan opsi "Tanpa Bagian" (value "")
                      yang jadi default lewat initialState — sebagian transaksi kas
                      bank (mis. Perjalanan Dinas) memang tak berdivisi. */}
                  {/* Bagian (divisi) — TERKUNCI ke bagian user login, KECUALI user
                      HO+FAP yang mengisi semua field manual. */}
                  <HrdInputGenerator
                    type={"Bagianv3"}
                    value={values}
                    name={"BagianID"}
                    title={"Bagian"}
                    onChange={customHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={false}
                    errors={errors}
                    disabled={!isFAP}
                  />

                  {/* Tanggal dengan input date biasa */}
                  <div className="w-full">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Tanggal *
                    </label>
                    <input
                      type="date"
                      value={toLocalDateString(values.Tanggal || new Date())}
                      onChange={(e) => {
                        const dateValue = e.target.value;
                        if (dateValue) {
                          const newDate = new Date(dateValue + "T00:00:00");
                          safeDateHandler(newDate, "Tanggal");
                        }
                      }}
                      className="appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-blue-500"
                      disabled={!!params.approval}
                    />
                  </div>

                  {/* Tanggal Keperluan — tanggal dana diperlukan (opsional). */}
                  <div className="w-full">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Tanggal Keperluan
                    </label>
                    <input
                      type="date"
                      value={values.TanggalKeperluan || ""}
                      onChange={(e) =>
                        customHandler(e.target.value, "TanggalKeperluan")
                      }
                      className="appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-blue-500"
                      disabled={!!params.approval}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  {/* No Cek / bilyet giro — sisi treasury, hanya FAP. */}
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"NoCek"}
                    title={"No Cek atau bilyed giro"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={isFAP}
                    errors={errors}
                    disabled={!!params.approval || !isFAP}
                  />
                </div>

                {/* File Attachment Section */}
                <div className="w-full px-3 mb-4">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Attachment
                    {selectedFile && (
                      <span className="text-green-600 text-xs ml-2">
                        ✓ File siap diupload
                      </span>
                    )}
                    {(uploadedFileName || values.File) && !selectedFile && (
                      <span className="text-blue-600 text-xs ml-2">
                        ✓ File tersedia
                      </span>
                    )}
                  </label>

                  <div className="flex items-center space-x-2">
                    <button
                      type="button"
                      onClick={() => fileInputRef.current.click()}
                      className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-300 rounded shadow-sm transition-colors duration-200"
                      disabled={!!params.approval}
                    >
                      {displayFileName ? "Ganti File" : "Pilih File"}
                    </button>

                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      disabled={!!params.approval}
                      onChange={handleFileChange}
                    />

                    {(uploadedFileName || values.File) && !selectedFile && (
                      <button
                        type="button"
                        onClick={() =>
                          getDataFromURL(values.File || uploadedFileName)
                        }
                        disabled={!!params.approval}
                        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 border border-blue-600 rounded shadow-sm transition-colors duration-200"
                      >
                        Lihat File
                      </button>
                    )}

                    {(selectedFile || uploadedFileName || values.File) &&
                      !params.approval && (
                        <button
                          type="button"
                          onClick={removeFile}
                          className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 border border-red-600 rounded shadow-sm transition-colors duration-200"
                        >
                          Hapus
                        </button>
                      )}
                  </div>

                  {displayFileName && (
                    <div className="mt-2 p-2 bg-gray-50 rounded border">
                      <div className="flex items-center">
                        <span className="text-lg mr-2">
                          {getFileIcon(displayFileName)}
                        </span>
                        <span className="text-sm text-gray-700 truncate">
                          {displayFileName}
                        </span>
                      </div>

                      {isUploading && (
                        <div className="mt-2 text-xs text-blue-600 flex items-center">
                          <span className="mr-1 animate-spin">⏳</span>
                          Mengupload file...
                        </div>
                      )}

                      {fileUploadError && (
                        <div className="mt-2 text-xs text-yellow-600 flex items-center">
                          <span className="mr-1">⚠️</span>
                          Nama file disimpan, tetapi upload gagal
                        </div>
                      )}

                      {uploadedFileName && !selectedFile && (
                        <p className="text-xs text-gray-500 mt-1">
                          UUID: {uploadedFileName.substring(0, 8)}...
                        </p>
                      )}
                    </div>
                  )}

                  <p className="text-gray-600 text-xs italic mt-1">
                    Ukuran maksimal 10MB. Format yang didukung: PDF, JPG, PNG,
                    DOC, DOCX
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"Keterangan"}
                    title={"Keterangan"}
                    onChange={changeHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={!!params.approval}
                  />
                </div>

                {/* Field Nominal */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  {isDownPaymentMode ? (
                    <>
                      {/* Field Nominal PO (hanya untuk down payment) */}
                      <div>
                        <HrdInputGenerator
                          type={"number"}
                          value={values}
                          name={"NominalPO"}
                          title={"Nominal PO"}
                          onChange={handleNominalPOChange}
                          touched={touched}
                          buttonTouched={buttonTouched}
                          size={"full"}
                          required={true}
                          errors={errors}
                          disabled={!!params.approval}
                        />
                        <p className="text-xs text-gray-500 mt-1">
                          Nilai dari Purchase Order
                        </p>
                      </div>

                      {/* Field Nominal Total (read-only, dihitung otomatis) */}
                      <div>
                        <HrdInputGenerator
                          type={"numberFormatSatu"}
                          value={values}
                          name={"Nominal"}
                          title={"Nominal Total"}
                          onChange={changeHandler}
                          touched={touched}
                          buttonTouched={buttonTouched}
                          size={"full"}
                          required={true}
                          errors={errors}
                          disabled={true}
                        />
                        <p className="text-xs text-gray-500 mt-1">
                          Total: PO + Detail Transaksi
                        </p>
                      </div>
                    </>
                  ) : (
                    /* Mode Regular: hanya 1 field Nominal (read-only, terformat) */
                    <div>
                      <HrdInputGenerator
                        type={"numberView"}
                        value={values}
                        name={"Nominal"}
                        title={"Nominal"}
                        onChange={changeHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={true}
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Total dari Detail Transaksi
                      </p>
                    </div>
                  )}
                </div>

                <hr />

                <div className="mb-4">
                  <div className="flex justify-between items-center mb-2">
                    <h3 className="text-lg font-semibold text-gray-700">
                      Detail Transaksi
                    </h3>
                    <div className="flex items-center gap-2">
                      {/* Di bagian tampilan info total */}
                      {isDownPaymentMode && values.PurchaseOrderID ? (
                        <>
                          <p className="text-sm text-gray-600">
                            Nominal PO:{" "}
                            <span className="font-semibold">
                              Rp {formatNumber(values.NominalPO)}
                            </span>
                            <span className="mx-2">+</span>
                            Detail:{" "}
                            <span className="font-semibold">
                              Rp{" "}
                              {formatNumber(
                                detail.reduce(
                                  (sum, item) =>
                                    sum + parseFloat(item.Nominal || 0),
                                  0,
                                ),
                              )}
                            </span>
                            <span className="mx-2">=</span>
                            Total:{" "}
                            <span className="font-bold text-blue-600">
                              Rp{" "}
                              {formatNumber(
                                parseFloat(values.NominalPO || 0) +
                                  detail.reduce(
                                    (sum, item) =>
                                      sum + parseFloat(item.Nominal || 0),
                                    0,
                                  ),
                              )}
                            </span>
                          </p>
                        </>
                      ) : (
                        <p className="text-sm text-gray-600">
                          Total:{" "}
                          <span className="font-bold text-blue-600">
                            Rp{" "}
                            {formatNumber(
                              detail.reduce(
                                (sum, item) =>
                                  sum + parseFloat(item.Nominal || 0),
                                0,
                              ),
                            )}
                          </span>
                        </p>
                      )}
                      <button
                        type="button"
                        onClick={ModalOpener}
                        className="ml-4 bg-green-500 hover:bg-green-600 text-white font-semibold py-1 px-3 rounded text-sm transition-colors duration-200"
                        disabled={!!params.approval}
                      >
                        + Tambah Detail
                      </button>
                    </div>
                  </div>
                  {detail.length > 0 ? (
                    <DynamicTableSimple
                      data={detail}
                      header={header}
                      Master={true}
                      OnClick={ModalOpener}
                      name={"Purchase Requisition"}
                      barang={barang.data}
                      edit={ModalEdit}
                      delete={ModalDelete}
                      account={detailAccount.data}
                    />
                  ) : (
                    <div className="text-center py-8 border border-dashed border-gray-300 rounded-lg">
                      <p className="text-gray-500">
                        Belum ada detail transaksi
                      </p>
                      <button
                        type="button"
                        onClick={ModalOpener}
                        className="mt-2 text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200"
                        disabled={!!params.approval}
                      >
                        Klik di sini untuk menambahkan detail
                      </button>
                    </div>
                  )}
                </div>

                {/* Debug Info Section (only in development) */}
                {process.env.NODE_ENV === "development" && (
                  <div className="mt-6 p-4 border border-yellow-300 bg-yellow-50 rounded-lg">
                    <h4 className="font-bold text-yellow-700 mb-2">
                      Debug Info:
                    </h4>
                    <p className="text-sm">
                      <strong>Mode:</strong>{" "}
                      {params.transid ? "UPDATE" : "INSERT"}
                    </p>
                    <p className="text-sm">
                      <strong>CashJournalID:</strong>{" "}
                      {params.transid
                        ? params.transid.replaceAll("-", "/")
                        : "N/A (Insert)"}
                    </p>
                    <p className="text-sm">
                      <strong>isDownPaymentMode:</strong>{" "}
                      {isDownPaymentMode ? "Yes" : "No"}
                    </p>
                    <p className="text-sm">
                      <strong>PurchaseOrderID:</strong>{" "}
                      {values.PurchaseOrderID || "Empty"}
                    </p>
                    <p className="text-sm">
                      <strong>SumberData:</strong>{" "}
                      {values.SumberData || "Empty"}
                    </p>
                    <p className="text-sm">
                      <strong>NominalPO:</strong> {values.NominalPO || "0"}
                    </p>
                    <p className="text-sm">
                      <strong>Available POs:</strong> {availablePOs.length}
                    </p>
                    <p className="text-sm">
                      <strong>Filtered POs:</strong> {filteredOptions.length}
                    </p>
                    <p className="text-sm">
                      <strong>API Route:</strong> all/GetPurchaseOrderPembayaran
                    </p>
                  </div>
                )}
              </div>
            </Card>

            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                  setModalDetail(initialStateModal);
                }}
              >
                {showModalEdit ? "Edit Detail" : "Tambah Detail"}
              </ModalHeader>
              <ModalBody>
                <form className="w-full " onSubmit={submitHandler}>
                  {inputBuilder.map(
                    (
                      {
                        type,
                        name,
                        title,
                        handler,
                        modifiers,
                        size,
                        required,
                        disabled,
                        edit,
                      },
                      id,
                    ) => {
                      if (!edit || showModalEdit) {
                        return (
                          <div key={id} className="mb-4">
                            <HrdInputGenerator
                              type={type}
                              value={modalDetail}
                              name={name}
                              title={title}
                              onChange={handler}
                              touched={touched}
                              buttonTouched={buttonTouched}
                              modifiers={modifiers}
                              size={size}
                              required={required}
                              errors={errors}
                              disabled={disabled}
                            />
                          </div>
                        );
                      }
                      return null;
                    },
                  )}
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                    setModalDetail(initialStateModal);
                  }}
                  ripple="dark"
                >
                  Batal
                </Button>

                <Button
                  color="green"
                  disabled={mutation.isLoading}
                  onClick={addDetail}
                  ripple="light"
                >
                  {showModalEdit ? "Ubah" : "Tambah"}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertKasBankPage;
